module.exports = __webpack_public_path__ + "static/media/23_tn.06e2231f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/23_tn.jpg
// module id = 332
// module chunks = 0